const IconOrder = ({ width = 24, height = 25, fill = "#252525" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2273 20.3549H8.76561C6.39207 20.3549 4.57118 19.4976 5.08839 16.0471L5.69064 11.3709C6.00947 9.64916 7.10767 8.99023 8.07126 8.99023H15.95C16.9278 8.99023 17.9622 9.69875 18.3306 11.3709L18.9329 16.0471C19.3721 19.1079 17.6008 20.3549 15.2273 20.3549Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2273 20.3549H8.76561C6.39207 20.3549 4.57118 19.4976 5.08839 16.0471L5.69064 11.3709C6.00947 9.64916 7.10767 8.99023 8.07126 8.99023H15.95C16.9278 8.99023 17.9622 9.69875 18.3306 11.3709L18.9329 16.0471C19.3721 19.1079 17.6008 20.3549 15.2273 20.3549Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2273 20.3549H8.76561C6.39207 20.3549 4.57118 19.4976 5.08839 16.0471L5.69064 11.3709C6.00947 9.64916 7.10767 8.99023 8.07126 8.99023H15.95C16.9278 8.99023 17.9622 9.69875 18.3306 11.3709L18.9329 16.0471C19.3721 19.1079 17.6008 20.3549 15.2273 20.3549Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2273 20.3549H8.76561C6.39207 20.3549 4.57118 19.4976 5.08839 16.0471L5.69064 11.3709C6.00947 9.64916 7.10767 8.99023 8.07126 8.99023H15.95C16.9278 8.99023 17.9622 9.69875 18.3306 11.3709L18.9329 16.0471C19.3721 19.1079 17.6008 20.3549 15.2273 20.3549Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2273 20.3549H8.76561C6.39207 20.3549 4.57118 19.4976 5.08839 16.0471L5.69064 11.3709C6.00947 9.64916 7.10767 8.99023 8.07126 8.99023H15.95C16.9278 8.99023 17.9622 9.69875 18.3306 11.3709L18.9329 16.0471C19.3721 19.1079 17.6008 20.3549 15.2273 20.3549Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3335 8.82083C15.3335 6.97388 13.8362 5.47659 11.9892 5.47659C11.0998 5.47285 10.2456 5.82352 9.61536 6.45109C8.98513 7.07866 8.63086 7.93143 8.63086 8.82083"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3335 8.82083C15.3335 6.97388 13.8362 5.47659 11.9892 5.47659C11.0998 5.47285 10.2456 5.82352 9.61536 6.45109C8.98513 7.07866 8.63086 7.93143 8.63086 8.82083"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3335 8.82083C15.3335 6.97388 13.8362 5.47659 11.9892 5.47659C11.0998 5.47285 10.2456 5.82352 9.61536 6.45109C8.98513 7.07866 8.63086 7.93143 8.63086 8.82083"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3335 8.82083C15.3335 6.97388 13.8362 5.47659 11.9892 5.47659C11.0998 5.47285 10.2456 5.82352 9.61536 6.45109C8.98513 7.07866 8.63086 7.93143 8.63086 8.82083"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3335 8.82083C15.3335 6.97388 13.8362 5.47659 11.9892 5.47659C11.0998 5.47285 10.2456 5.82352 9.61536 6.45109C8.98513 7.07866 8.63086 7.93143 8.63086 8.82083"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2861 12.3066H14.25"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2861 12.3066H14.25"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2861 12.3066H14.25"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2861 12.3066H14.25"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2861 12.3066H14.25"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.77244 12.3066H9.73633"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.77244 12.3066H9.73633"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.77244 12.3066H9.73633"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.77244 12.3066H9.73633"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.77244 12.3066H9.73633"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconOrder;
